var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/helpers/extends", "react", "prop-types", "../../Teasers/TeaserSidebar/TeaserSidebar", "../../UI/TitlesElement/TitlesElement"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/helpers/extends"), require("react"), require("prop-types"), require("../../Teasers/TeaserSidebar/TeaserSidebar"), require("../../UI/TitlesElement/TitlesElement"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.react, global.propTypes, global.TeaserSidebar, global.TitlesElement);
    global.ProgramSidebar = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _extends2, _react, _propTypes, _TeaserSidebar, _TitlesElement) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = _exports.ProgramSidebar = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _TeaserSidebar = _interopRequireDefault(_TeaserSidebar);
  _TitlesElement = _interopRequireDefault(_TitlesElement);

  var ProgramSidebar = function ProgramSidebar(_ref) {
    var teasers = _ref.teasers;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "row large-up-1"
    }, teasers && teasers.map(function (teaser) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: teaser.id,
        className: "column column-block"
      }, /*#__PURE__*/_react.default.createElement(_TeaserSidebar.default, (0, _extends2.default)({
        titlesElement: /*#__PURE__*/_react.default.createElement(_TitlesElement.default, {
          title: teaser.title,
          subtitle: teaser.subtitle
        })
      }, teaser)));
    }));
  };

  _exports.ProgramSidebar = ProgramSidebar;
  ProgramSidebar.defaultProps = {
    teasers: []
  };
  ProgramSidebar.propTypes = {
    teasers: _propTypes.default.arrayOf(_propTypes.default.shape())
  };
  var _default = ProgramSidebar;
  _exports.default = _default;
});